// window.location can't be stubbed in tests (jsdom marks it unforgeable), so
// full-page navigations go through this module and tests mock it instead.
export function navigateTo(url: string) {
  globalThis.location.assign(url);
}

export function reloadPage() {
  globalThis.location.reload();
}
